import $ from 'jquery';
import loading from '../../../views/partials/loading/loading';
import hamburger from '../../../views/partials/hamburger/hamburger';
import filters from '../../../views/partials/filters/filters';
import mobileLayer from '../../../views/partials/mobile-layer/mobile-layer';
import aos from '../libs/aos';
import footer from '../../../views/partials/footer/footer';
import marquee from '../../../views/partials/marquee/marquee';
import header from '../../../views/partials/header/header';
import recaptchaAccessibility from '../libs/recaptcha-accessibility';

export default {
    init() {
    },

    finalize() {
        loading();
        hamburger();
        setTimeout(function () {
            window.setLoading(false);
        }, 1500);

        //receve event 
        if (document.addEventListener) {
            document.addEventListener('loading-ended', aos, false);
        } else {
            document.attachEvent('loading-ended', aos);
        }

        function startAnim() {
            var list = $('.progetto-preview');
            showElem(list, 0);
        };
        function showElem(list, index) {
            if (index < list.length) {
                $(list[index]).find('.progetto-preview__box').addClass('show');
                setTimeout(function () {
                    index += 1;
                    showElem(list, index);
                }, 200);
            }
        }

        if (document.addEventListener) {
            document.addEventListener('grid-loaded', startAnim, false);
        } else {
            document.attachEvent('grid-loaded', startAnim);
        }

        if ($('.template-portfolio').length > 0) {
            filters();
        }
        if ($('.error404').length > 0) {
            marquee();
        }
        
        setTimeout(function () {
            window.setLoading(false);
        }, 500);

        mobileLayer();
        header();
        footer();
        recaptchaAccessibility();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js